var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var AbstractViewerController = require("./../../abstractViewerController.js");

var LineInteractionView = require("./lineInteractionView.js");
var LineInteractionModel = require("./lineInteractionModel.js");

var LineViewerController = function(archLayers, dependencies, configuration) {
    AbstractViewerController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(LineViewerController, AbstractViewerController);
LineViewerController.inject = AbstractViewerController.inject;

module.exports = LineViewerController;

LineViewerController.prototype.beforeLoad = function () {
    AbstractViewerController.prototype.beforeLoad.call(this);
};

LineViewerController.prototype.getDataType = function () {
    return cio_datamodel.LineData;
};

LineViewerController.prototype.getInteractionViewType = function () {
    return LineInteractionView;
};

LineViewerController.prototype.getInteractionModelType = function () {
    return LineInteractionModel;
};
